import React from "react";
import * as PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { css } from "@emotion/css";
import { measurePropType, indicatorResultPropType } from "../../propTypes";
import { indicators } from "../../constants";
import IndicatorSelector from "./ResultsIndicatorSelector";
import MaritalStatusSelector from "../MaritalStatusSelector";
import MeasureSelector from "../MeasureSelector";
import ResultsExporter from "./ResultsExporter";
import ResultsDataTable from "../AGGrid/ResultsDataTable";

const classes = {
    container: css`
        margin-top: 20px;
    `,
    gridSelectors: css`
        display: flex;
    `,
    leftSelector: css`
        margin-right: 30px;
    `,
    table: css`
        margin-top: 10px;
    `,
};

const Results = ({ t, ...rest }) => {
    if (!rest.results || rest.results.length === 0) {
        return <div className={classes.container}>{t("Select a run to view results.")}</div>;
    }

    return (
        <div className={classes.container}>
            <div className={classes.gridSelectors}>
                <MeasureSelector
                    value={rest.selectedMeasure}
                    className={classes.leftSelector}
                    onChange={rest.onChangeMeasure}
                />
                <IndicatorSelector
                    indicators={indicators.filter(
                        (indicator) => rest.selectedMeasure === "percentage" || indicator.value !== "ratioModernAny"
                    )}
                    value={rest.selectedIndicator}
                    className={classes.leftSelector}
                    onChange={rest.onChangeIndicator}
                />
                <MaritalStatusSelector
                    value={rest.selectedMaritalStatus}
                    onChange={rest.onChangeMaritalStatus}
                />
            </div>

            <ResultsDataTable
                measure={rest.selectedMeasure}
                results={rest.results}
                comparison={rest.comparison}
                className={classes.table}
            />

            <div>
                <ResultsExporter
                    comparison={rest.comparison}
                    selectedMeasures={rest.selectedExportedMeasures}
                    indicators={indicators}
                    selectedIndicators={rest.selectedExportedIndicators}
                    disableSelectedResultsDownload={rest.disableSelectedResultsDownload}
                    disableAllResultsDownload={rest.disableAllResultsDownload}
                    disableAllDataDownload={rest.disableAllDataDownload}
                    onToggleMeasure={rest.onToggleExportedMeasure}
                    onToggleIndicator={rest.onToggleExportedIndicator}
                    onDownloadSelectedResults={rest.onDownloadSelectedResults}
                    onDownloadAllResults={rest.onDownloadAllResults}
                    onDownloadAllData={rest.onDownloadAllData}
                />
            </div>
        </div>
    );
};

Results.propTypes = {
    comparison: PropTypes.bool,
    selectedMeasure: measurePropType.isRequired,
    selectedIndicator: PropTypes.string.isRequired,
    selectedMaritalStatus: PropTypes.string.isRequired,
    results: PropTypes.arrayOf(indicatorResultPropType),
    selectedExportedMeasures: PropTypes.arrayOf(measurePropType),
    selectedExportedIndicators: PropTypes.arrayOf(PropTypes.string),
    disableSelectedResultsDownload: PropTypes.bool.isRequired,
    disableAllResultsDownload: PropTypes.bool.isRequired,
    disableAllDataDownload: PropTypes.bool,
    onChangeMeasure: PropTypes.func.isRequired,
    onChangeIndicator: PropTypes.func.isRequired,
    onChangeMaritalStatus: PropTypes.func.isRequired,
    onToggleExportedMeasure: PropTypes.func.isRequired,
    onToggleExportedIndicator: PropTypes.func.isRequired,
    onDownloadSelectedResults: PropTypes.func.isRequired,
    onDownloadAllResults: PropTypes.func.isRequired,
    onDownloadAllData: PropTypes.func,
};

Results.defaultProps = {
    comparison: false,
    results: [],
    selectedExportedMeasures: [],
    selectedExportedIndicators: [],
    disableAllDataDownload: true,
};

export default withTranslation()(Results);
